import styles from "./Divider.module.css";

const Divider = () => <hr className={styles.divider} />;

export default Divider;
